import { LINK_REQUEST, LINK_SUCCESS, LINK_FAILURE } from 'app/actions/eljur/link';

const defaultState = {
  loading: false,
  link: '',
};

const link = (state = defaultState, action) => {
  switch (action.type) {

    case LINK_REQUEST: {
      return { ...state, loading: true };
    }

    case LINK_SUCCESS: {
      return { link: action.payload, loading: false };
    }

    case LINK_FAILURE: {
      return { link: '', loading: false };
    }

    default:
  }
  return state;
};

export default link;
